import { IApplicationState } from '../../types/redux';

export function filterBusinessAppointmentsIdsSelector(state: IApplicationState): string[] {
  return state.businessAppointments.filterBusinessAppointmentsIds;
}
